var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-hourglass-half" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("general_test")) + "\n    ")
        ],
        1
      ),
      _vm.hasResults
        ? _c(
            "q-alert",
            { attrs: { type: "warning", icon: "fa fa-exclamation-triangle" } },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("general_test_has_results")) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error,
                disabled: _vm.hasResults
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("introduction"),
                rows: "1",
                "max-height": 100,
                type: "textarea",
                error: _vm.$v.description.$error,
                disabled: _vm.hasResults
              },
              on: { input: _vm.$v.description.$touch },
              model: {
                value: _vm.description,
                callback: function($$v) {
                  _vm.description = $$v
                },
                expression: "description"
              }
            })
          ],
          1
        )
      ]),
      _c("q-table", {
        staticClass: "q-my-lg",
        attrs: {
          data: _vm.questions,
          columns: _vm.columns_questions,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request_questions
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "q-table-title" }, [
                  _vm._v(_vm._s(_vm.$t("questions")))
                ]),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new_f"),
                    disable: _vm.hasResults
                  },
                  on: {
                    click: function($event) {
                      return _vm.showQuestion(0)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.title) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "qty_answers", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.qty_answers) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "actions",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "fas fa-pencil-alt",
                          disabled: _vm.hasResults
                        },
                        on: {
                          click: function($event) {
                            return _vm.showQuestion(props.row.actions)
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-trash-alt",
                          disable: _vm.hasResults
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmRemove(props.row.actions)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("minimum_score"),
                type: "number",
                error: _vm.$v.minimum_score.$error,
                disabled: _vm.hasResults
              },
              on: { input: _vm.$v.minimum_score.$touch },
              model: {
                value: _vm.minimum_score,
                callback: function($$v) {
                  _vm.minimum_score = $$v
                },
                expression: "minimum_score"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                "float-label": _vm.$t("time_to_finish"),
                type: "time",
                format: "HH:mm:ss",
                error: _vm.$v.time_to_finish.$error,
                disabled: _vm.hasResults
              },
              on: { input: _vm.$v.time_to_finish.$touch },
              model: {
                value: _vm.time_to_finish,
                callback: function($$v) {
                  _vm.time_to_finish = $$v
                },
                expression: "time_to_finish"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                "float-label": _vm.$t("publish_date"),
                format: "DD/MM/YYYY",
                disabled: _vm.hasResults
              },
              model: {
                value: _vm.publish_date,
                callback: function($$v) {
                  _vm.publish_date = $$v
                },
                expression: "publish_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                "float-label": _vm.$t("unpublish_date"),
                format: "DD/MM/YYYY",
                disabled: _vm.hasResults
              },
              model: {
                value: _vm.unpublish_date,
                callback: function($$v) {
                  _vm.unpublish_date = $$v
                },
                expression: "unpublish_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.tags,
                "float-label": _vm.$t("tags"),
                error: _vm.$v.tag.$error,
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": "",
                disabled: _vm.hasResults
              },
              on: { input: _vm.$v.tag.$touch },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fas fa-clipboard-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "groups",
              icon: "fas fa-users",
              label: _vm.$t("groups")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.areas,
                        "float-label": _vm.$t("areas"),
                        error: _vm.$v.area.$error,
                        multiple: "",
                        chips: "",
                        disabled: _vm.hasResults
                      },
                      on: { input: _vm.$v.area.$touch },
                      model: {
                        value: _vm.area,
                        callback: function($$v) {
                          _vm.area = $$v
                        },
                        expression: "area"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disabled: _vm.hasResults
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disabled: _vm.hasResults
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          ),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "groups" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.user_groups,
                        "float-label": _vm.$t("groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disabled: _vm.hasResults
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses,
                disable: _vm.disableStatus
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_general_tests" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "primary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveTest()
                }
              }
            })
          ],
          1
        )
      ]),
      _c("new-question", {
        attrs: {
          id_test: _vm.id_test,
          id_question: _vm.id_question,
          add_question: _vm.add_question,
          has_results: _vm.hasResults
        },
        on: {
          returnToQuestions: function($event) {
            return _vm.returnToQuestions()
          }
        }
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }